import {grey} from "@mui/material/colors";

export const cellInActive = grey["200"];